import React from "react";
import { Globe } from "lucide-react";
import { getPlatformIcon } from "../../utils/logo-getter";
import { cn } from "../../utils/classMerger";
import { formatPlatform, platformIconKey } from "./types";

export type PlatformChipTone = "connected" | "disconnected" | "paused";

interface PlatformChipProps {
    platform: string;
    tone: PlatformChipTone;
    trailing?: React.ReactNode;
    className?: string;
}

const toneClasses: Record<PlatformChipTone, string> = {
    connected: "border-gray-200 bg-white text-primary",
    disconnected: "border-[#c62828] bg-white text-[#c62828]",
    paused: "border-secondary bg-lightSecondary text-primary",
};

const PlatformChip: React.FC<PlatformChipProps> = ({
    platform,
    tone,
    trailing,
    className,
}) => {
    const icon = getPlatformIcon(platformIconKey(platform));

    return (
        <span
            className={cn(
                "inline-flex w-full items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-medium",
                toneClasses[tone],
                className
            )}
        >
            {/* Fixed-size slot: logo-getter renders w-6 h-6, and an unknown platform
                returns null — either would knock the chip rows out of alignment. */}
            <span className="flex h-4 w-4 shrink-0 items-center justify-center [&>svg]:h-4 [&>svg]:w-4">
                {icon ?? <Globe className="h-4 w-4 text-gray-400" />}
            </span>
            <span className="truncate">{formatPlatform(platform)}</span>
            {trailing}
        </span>
    );
};

export default PlatformChip;
